import clsx from 'clsx';
import { FunctionComponent, PropsWithChildren } from 'react';

import styles from './FullWindowModalBody.module.scss';

interface FullWindowModalBodyProps extends PropsWithChildren {
    className?: string;
}

/**
 * Middle slot of `FullWindowModal`. Grows to fill the remaining vertical
 * space between header and footer, with internal scrolling when content
 * overflows. Defaults to a flex column so a single child using `flex: 1`
 * fills the available area — typical for preview/wizard layouts.
 */
export const FullWindowModalBody: FunctionComponent<FullWindowModalBodyProps> = ({ children, className }) => {
    return <div className={clsx(styles.body, className)}>{children}</div>;
};

export default FullWindowModalBody;
